import { render, staticRenderFns } from "./APIDocumentation.vue?vue&type=template&id=cc73efa4"
import script from "./APIDocumentation.vue?vue&type=script&lang=js"
export * from "./APIDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports